var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tw-flex tw-flex-col" }, [
    _c(
      "div",
      { staticClass: "max-width tw-flex tw-flex-col league-container" },
      [
        _c("NavigationTabs", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show"
            }
          ],
          attrs: {
            tab: _vm.tab,
            selectedManOfTheMatch: _vm.selectedManOfTheMatch
          },
          on: { tabChanged: _vm.tabChanged }
        }),
        _c("ManOfTheMatchCompetition", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tab === 1,
              expression: "tab === 1"
            }
          ],
          attrs: { tab: _vm.tab }
        }),
        _vm.tab === 2
          ? _c("ManOfTheMatchSettings", {
              attrs: { selectedManOfTheMatch: _vm.selectedManOfTheMatch },
              on: { getInitialData: _vm.getInitialData }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }